"use strict";

exports.__esModule = true;

var _superQuery = _interopRequireDefault(require("./core/superQuery"));

exports.default = _superQuery.default;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}